import React, { useEffect } from 'react';
import IconTint from 'react-icon-tint';
import actionsIcon from '../assets/icons/ic_actions_white.svg'
import flyerIcon from '../assets/icons/ic_flyer.svg'
import mapIcon from '../assets/icons/ic_map.svg'
import videoIcon from '../assets/icons/ic_videotape.svg'
import usersIcon from '../assets/icons/ic_users.svg'
import phoneIcon from '../assets/icons/ic_phone.svg'
import helpIcon from '../assets/icons/ic_help.svg'
import { useAtom } from 'jotai';
import { isPageChanged, selectedPage, loggedInUser } from './store/DataStore';
import { currentRobot } from './store/DataStore';
import { getRobotCapabilities } from '../lib/robotCapabilities';


const baseNavbarItems = [
    { label: "Actions", icon: actionsIcon, isSelected: true, key: 0 },
    { label: "Tasks", icon: flyerIcon, isSelected: false, key: 1 },
    { label: "Map", icon: mapIcon, isSelected: false, key: 2 },
    { label: "Video Library", icon: videoIcon, isSelected: false, key: 3 },
    // Users will be conditionally added
    { label: "Support", icon: phoneIcon, isSelected: false, key: 5 },
    { label: "Help Center", icon: helpIcon, isSelected: false, key: 7 },
];

const NavbarHome = () => {
    const [currentUser] = useAtom(loggedInUser);
    const [selectedRobot] = useAtom(currentRobot);
    const [savedPos, setSavedPos] = useAtom(selectedPage);


    const capabilities = getRobotCapabilities(selectedRobot);

    useEffect(() => {
        if (!capabilities.supportsMap && savedPos === 2) {
            setSavedPos(0);
        }
    }, [capabilities.supportsMap, savedPos, setSavedPos]);

    let navbarItems = baseNavbarItems.filter(item => {
        if (item.key === 2) {
            return capabilities.supportsMap;
        }

        return true;
    });

    if (['Admin', 'Tech Support'].includes(currentUser?.role)) {
        navbarItems = [
            ...navbarItems.slice(0, 4),
            { label: "Users", icon: usersIcon, isSelected: false, key: 4 },
            ...navbarItems.slice(4),
        ];
    }

    return (
        <div className="w-full h-fit mt-10 px-3">
            {navbarItems.map((item, index) => (
                <NavbarHomeItem
                    key={item.key}
                    positionIndex={index}
                    routeKey={item.key}
                    icon={item.icon}
                    label={item.label}
                    navbarItems={navbarItems}
                    isSelected={savedPos === item.key}
                />
            ))}
        </div>
    );
};

const NavbarHomeItem = ({ icon: imgSrc, label, isSelected: selected, positionIndex, routeKey }) => {
    const [savedPos, setSavedPos] = useAtom(selectedPage);
    const [isFragmentChanged, setIsFragmentChanged] = useAtom(isPageChanged);

    useEffect(() => {
        if(savedPos === 3 && isFragmentChanged){
            setIsFragmentChanged(false);
        }
    }, [isFragmentChanged, savedPos, setIsFragmentChanged]);
    
    const selectItem = () => {
        if(!isFragmentChanged){
            setSavedPos(routeKey);
        }
    };

    return (
        <div>
            {selected && savedPos !== 6 ?
                <div className="flex items-center transition-all duration-150 2xl:py-[23px] lg:py-4 pl-9 cursor-pointer bg-white rounded-xl">
                    <IconTint src={imgSrc} color='#152FF5' />
                    <span className="ml-3 text-[#152FF5] font-heebo 2xl:text-[21px] lg:text-lg select-none">{label}</span>
                </div> :
                <div className="flex items-center transition-all duration-150 2xl:py-[23px] lg:py-4 pl-9 cursor-pointer rounded-xl hover:bg-slate-50 hover:bg-opacity-5" onClick={selectItem}>
                    <IconTint src={imgSrc} color='#FFFFFF' />
                    <span className="ml-3 text-white font-heebo font-light 2xl:text-[21px] lg:text-lg select-none">{label}</span>
                </div>
            }
        </div>
    );
};

export default NavbarHome;




